function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "oz2nx446qa",
  width: "256.2%",
  height: "256.2%",
  x: "-78.1%",
  y: "-71.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 5,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "v20acmq10b",
  cx: 40,
  cy: 40,
  r: 40
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-148.000000, -129.000000) translate(148.000000, 129.000000)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#oz2nx446qa)",
  xlinkHref: "#v20acmq10b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#v20acmq10b"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#001854"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.913 41.097c0-.589-.454-1.15-1.282-1.665-2.356-1.467-3.811-4.023-3.811-6.798v-6.476c0-6.202-4.305-11.398-10.09-12.763.014-.115.02-.232.02-.35 0-1.682-1.362-3.045-3.043-3.045-1.682 0-3.045 1.363-3.045 3.044 0 .119.008.236.02.35-5.784 1.366-10.089 6.562-10.089 12.764v6.476c0 2.775-1.454 5.331-3.81 6.798-.828.515-1.283 1.076-1.283 1.665 0 2.07 5.637 3.814 13.319 4.343.175 2.547 2.296 4.56 4.888 4.56s4.712-2.013 4.888-4.56c7.68-.529 13.318-2.273 13.318-4.343",
  transform: "translate(-148.000000, -129.000000) translate(148.000000, 129.000000) translate(10.000000, 10.000000)"
})))));

var SvgIconBellLarge = function SvgIconBellLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBellLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bell-large.94c5f19f.svg";
export { ForwardRef as ReactComponent };